import { List } from '@mui/material';
import { useCallback, useReducer } from 'react';
import { contenStateReducer, initialContentState, Section } from './utils/content-toggle-reducer';
import { sectionDefinition } from './utils/sections';
import { useFormikContext } from 'formik';
import { CancellationDueDeath } from 'cancellations/view-models/cancellation-due-death';
import { PmiButton } from 'shell/components/shared/button';

interface CancellationDueDeathContentProps {
  disabledFromAct?: boolean;
}

const CancellationDueDeathContent = ({
  disabledFromAct = false,
}: CancellationDueDeathContentProps): React.ReactElement => {
  const [contentState, dispatchContentAction] = useReducer(contenStateReducer, initialContentState);
  const formContext = useFormikContext<CancellationDueDeath>();
  const { activeStep } = formContext.values;

  const toggleAccordion = useCallback(
    (section: Section) => {
      const type = 'toggle';
      const payload = {
        section,
      };
      dispatchContentAction({ type, payload });
    },
    [dispatchContentAction]
  );

  const activeAccordions = sectionDefinition[activeStep]?.map((accordion) => (
    <accordion.accordion
      key={accordion.key}
      expanded={contentState[accordion.key]}
      toggle={() => toggleAccordion(accordion.key)}
      disabled={disabledFromAct}
    />
  ));

  return (
    <List style={{ overflow: 'auto', minHeight: '100%' }}>
      {activeAccordions}
      <div style={{ marginTop: '16px', display: 'flex', justifyContent: 'flex-end' }}>
        <PmiButton variant="outlined" color="cdmBrand" onClick={() => formContext.resetForm()}>
          Ripulisci
        </PmiButton>
      </div>
    </List>
  );
};

CancellationDueDeathContent.displayName = 'Cancellation due death page content';

export default CancellationDueDeathContent;
